import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Calendar, CircleQuestionMark } from "lucide-react";
export default function BookYourChateauguayService() {
  return <section data-section-id="252502" id="צרו-קשר" className="bg-background text-foreground py-20 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(0,0,0,0.03)_0%,transparent_70%)] pointer-events-none" />
      
      <div className="page-container relative z-10 max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default mb-6 leading-tight text-primary">
          זקוקים למטפל סיעודי באופן מיידי?
        </h2>
        
        <p className="text-lg md:text-xl mb-10 text-muted-foreground font-default max-w-2xl mx-auto leading-relaxed">
          אנחנו כאן כדי לספק לכם שקט נפשי וטיפול מקצועי ומסור. הצוות שלנו זמין עבורכם לכל שאלה או תיאום מהיר של מטפל מוסמך עד הבית.
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6">
          <Button asChild size="lg" className="w-full sm:w-auto h-14 px-8 text-lg font-semibold rounded-lg shadow-lg shadow-primary/10 transition-transform hover:scale-105 bg-primary text-primary-foreground">
            <Link to="/ContactPage">
              <SafeHydrate><Calendar className="mr-2 h-5 w-5" /></SafeHydrate>
              תיאום ייעוץ ראשוני חינם
            </Link>
          </Button>
          
          <Button asChild size="lg" variant="outline" className="w-full sm:w-auto h-14 px-8 text-lg font-semibold rounded-lg bg-transparent border-border text-foreground hover:bg-accent hover:text-accent-foreground transition-colors">
            <Link to="/ProfessionalBlogPage">
              <CircleQuestionMark className="mr-2 h-5 w-5" />
              איך בוחרים מטפל מתאים?
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}